import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    aalignItems: 'flex-start',
    padding: '1.875rem',
    width: '37.5rem',
    height: '100%',
    color: 'white',
  },

  title: {
    fontFamily: 'Sora !important',
    marginBottom: 15,
    fontWeight: '400 !important',
    fontSize: '26px',
    lineHeight: '32px',
  },

  subtitle: {
    opacity: 0.85,
    fontFamily: 'Nunito !important',
    marginTop: 0,
    marginBottom: 20,
    fontWeight: '300 !important',
    fontSize: '18px',
    lineHeight: '24px',
    letterSpacing: '0.15px',
  },

  image: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'center',
    width: '380px',
    marginTop: '32px',
  },
}))

export { useStyles }
